import React from 'react';
import { SubscriptionInfo, UserActions } from '@chegg/commerce-utils';
import { captureError, Severity } from '@chegg/observability';
import { ADD_PAYMENT_METHOD, EDIT_PAYMENT_METHOD, ONE_CLICK_ERROR_LOCATION } from './constants';
import { PaymentMethodHeading, StyledSaleBannerWithBadge } from './styled';
import { CW_TEAM_NAME } from '../../constants/newRelic';
var onError = function onError(error) {
  return captureError({
    error: error,
    severity: Severity.ERROR,
    location: ONE_CLICK_ERROR_LOCATION
  }, {
    teamName: CW_TEAM_NAME
  });
};
var CartCheckoutHeader = function CartCheckoutHeader(_ref) {
  var _ref$showOnlyPM = _ref.showOnlyPM,
    showOnlyPM = _ref$showOnlyPM === void 0 ? false : _ref$showOnlyPM,
    content = _ref.content,
    cardActionMode = _ref.cardActionMode,
    newUserNoMop = _ref.newUserNoMop,
    allowPlanSelection = _ref.allowPlanSelection,
    addPaymentMethodHeading = _ref.addPaymentMethodHeading,
    editPaymentMethodHeading = _ref.editPaymentMethodHeading,
    selectedPrice = _ref.selectedPrice,
    isCouponApplied = _ref.isCouponApplied,
    priceWithDiscount = _ref.priceWithDiscount,
    authorization = _ref.authorization,
    saleBannerHeaderContent = _ref.saleBannerHeaderContent,
    saleBannerBadgeContent = _ref.saleBannerBadgeContent,
    savingsPercentage = _ref.savingsPercentage,
    action = _ref.action,
    country = _ref.country;
  var showSaleBanner = action !== UserActions.JOIN && savingsPercentage > 0 && country === 'US';
  return /*#__PURE__*/React.createElement(React.Fragment, null, !showOnlyPM && /*#__PURE__*/React.createElement(SubscriptionInfo, {
    content: content,
    headingLevel: 2,
    price: selectedPrice,
    isCouponApplied: isCouponApplied,
    priceWithDiscount: priceWithDiscount,
    authorization: authorization,
    onError: onError,
    saleBanner: showSaleBanner && /*#__PURE__*/React.createElement(StyledSaleBannerWithBadge, {
      totalSavingsPercentage: String(savingsPercentage),
      content: saleBannerHeaderContent,
      saleBadgeContent: saleBannerBadgeContent,
      dataTestId: "one-click-sale-banner-with-badge",
      compact: true
    })
  }), !allowPlanSelection && cardActionMode !== 'None' && !newUserNoMop && /*#__PURE__*/React.createElement(PaymentMethodHeading, null, cardActionMode === 'Add' ? addPaymentMethodHeading || ADD_PAYMENT_METHOD : editPaymentMethodHeading || EDIT_PAYMENT_METHOD));
};
CartCheckoutHeader.displayName = 'CartCheckoutHeader';
export default CartCheckoutHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/CartCheckoutHeader.js
// module id = 1462
// module chunks = 11